import Ajax from '../../../../util/ajax';
export function zigbeeOn(nid, eid) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/6/command/on';
        ajax.post(url);
    };
}
